var recaptchaForm = {
    setupValidation: function () {
        var form = $('#recaptcha').closest('form');

        if (form) {
            $(form).submit(function () {
                return recaptchaForm.validate(form);
            });
        }
    },
    validate: function (form) {
        var response = grecaptcha.getResponse();
        //recaptcha failed validation
        if (response.length === 0) {
            var errorElement = document.getElementById('captchaError');
            var errorMessage = $(errorElement).data('error-message');
            errorElement.innerHTML = errorMessage;
            return false;
        }
        //recaptcha passed validation
        else {
            document.getElementById('captchaError').innerHTML = "";
            $('.googleRecaptchaClass').val(response);
            return true;
        }
    },
    response: function (form) {
        return grecaptcha.getResponse();
    }
};
$(function () {
    recaptchaForm.setupValidation();

    $(document).ajaxComplete(function (event, request, settings) {
        if (typeof grecaptcha !== 'undefined' && $('#recaptcha').is(':empty')) {
            grecaptcha.render('recaptcha');
            recaptchaForm.setupValidation();
        }
    });
});